import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Overlay from "/containers/general/overlay"
import { Redirect } from "react-router-dom"
import LoadingOverlay from "containers/general/loadingOverlay"
import { compose } from "redux"
import { getExecWeeklyPayloadInternal, loadingStatus } from "actions"
import Chart from "react-apexcharts"
import Title from "containers/general/title"
import _, { property } from "lodash"
import settings from "settings"
import { Pie, HorizontalBar, Bar, Line } from "react-chartjs-2"
import colorArray from "helpers/colorArray"
import moment from "moment"
import ReactTable from "react-table"
import percentChange from "helpers/percentChange"
import ReactSelect from "react-select"
import times from "helpers/times"
import yearlyTimes from "helpers/yearlyTimes"
import RenderOverride from "renderOverrides/RenderOverride"
import numeral from "numeral"
import helpers from "helpers/helpers"

let limit = 20
// Internal
class Executive extends Component {
	constructor(props) {
		super(props)
		this.state = {
			name: "Company Wide",
			active: "all",
			times: times(),
			options: {
				year: {
					value: parseInt(moment.unix(times().endWeek).format("YYYY")),
					label: parseInt(moment.unix(times().endWeek).format("YYYY")),
				},
				week: { value: moment().subtract(7, "days").isoWeek(), label: moment().subtract(7, "days").isoWeek() },
				active: { value: "all", label: "Company Wide" },
			},
			selectedYear: parseInt(moment.unix(times().endWeek).format("YYYY")),
			selectedWeek: moment().subtract(7, "days").isoWeek(),

			startWeek: times().lastWeek,
			endWeek: times().lastWeekEnd,
			startYear: moment().startOf("year").unix(),
			priorStartWeek: times().priorStartWeek,
			priorEndWeek: times().priorEndWeek,

			sales: [],
			closings: [],
			bustouts: [],
			allSales: [],
			allBusts: [],
			weeklyTotals: {},
			propertyBreakout: {},
			payload: {},
			payloadStatus: false,
			developerSplit: _.has(settings, `execDeveloperSplit`),
		}
		if (this.state.selectedWeek == 53) {
			// We split week 53 and week 1 into two weeks for eoy reporting.  week 1 is internationally known as the week that contains jan 1, but we split it.
			if (_.has(yearlyTimes, `${this.state.selectedYear - 1}.lastWeek.start`)) {
				this.state.selectedYear--
				this.state.options.year = { value: this.state.selectedYear, label: this.state.selectedYear }
				this.state.startWeek = yearlyTimes[this.state.selectedYear].lastWeek.start
				this.state.endWeek = yearlyTimes[this.state.selectedYear].lastWeek.end
				this.state.startDayName = moment.unix(this.state.startWeek).format("dddd")
				this.state.endDayName = moment.unix(this.state.endWeek).format("dddd")
				this.state.times.year = this.state.selectedYear
				this.state.times.curWeek = 53
				this.state.times.curMonth = 12
			}
		}
		// 2021 ended with only 52 weeks (https://weeknumber.com/2021/52) - so if this is the case, we need to check and see if wee k52 is selected and if there are only 52 weeks.  If true, then the last day is the 31st of december
		if (this.state.selectedWeek == 52 && moment().year(this.state.selectedYear).isoWeeksInYear() == 52) {
			console.log("%c" + `In week 52 - only 52 weeks this selected year.`, "background: #222; color: #bada55")
			this.state.endWeek = moment().year(this.state.selectedYear).endOf("year").endOf("day").unix()
			this.state.endDayName = moment.unix(this.state.endWeek).format("dddd")
		}
		this.sale_date = "sale_date"
		this.closing_date = "closing_date"
		this.bustout_date = "bustout_date"
		if (settings?.weekly?.useInputDate) {
			this.sale_date = "addedDate"
			this.closing_date = "closing_report_time"
			this.bustout_date = "bustout_report_time"
		}
	}

	componentDidMount() {
		this.getData()
	}

	getData = async () => {
		let d = await this.props.getExecWeeklyPayloadInternal({
			week: this.state.selectedWeek,
			year: this.state.selectedYear,
			useInputDate: settings?.weekly?.useInputDate,
		})
		this.setState({ payload: d.data.data.data, payloadStatus: true }, () => {
			this.changeReport()
		})
	}

	changeTime = (v, type) => {
		let state = _.cloneDeep(this.state)
		if (type == "year") {
			state.selectedYear = v.value
		} else if (type == "week") {
			state.selectedWeek = v.value
		}
		state.options.year = { value: state.selectedYear, label: state.selectedYear }
		state.options.week = { value: state.selectedWeek, label: state.selectedWeek }
		/* let start = moment().year(state.selectedYear).week(state.selectedWeek).startOf("isoweek").unix() */
		//let start = moment().year(state.selectedYear).isoWeek(state.selectedWeek).startOf("isoweek").unix()
		let start = moment(`${state.selectedYear}${state.selectedWeek}`, "YYYYW").unix()
		let end = moment.unix(start).endOf("isoweek").unix()
		state.startDayName = false
		state.endDayName = false
		// EOY
		if (state.selectedWeek == 53) {
			start = yearlyTimes[state.selectedYear].lastWeek.start
			end = yearlyTimes[state.selectedYear].lastWeek.end
			state.startDayName = moment.unix(start).format("dddd")
			state.endDayName = moment.unix(end).format("dddd")
		} else if (state.selectedWeek === 0 && _.has(yearlyTimes, `${state.selectedYear}.firstWeek.start`)) {
			start = yearlyTimes[state.selectedYear].firstWeek.start
			end = yearlyTimes[state.selectedYear].firstWeek.end
			state.startDayName = moment.unix(start).format("dddd")
			state.endDayName = moment.unix(end).format("dddd")
		}

		// 2021 ended with only 52 weeks (https://weeknumber.com/2021/52) - so if this is the case, we need to check and see if week 52 is selected and if there are only 52 weeks.  If true, then the last day is the 31st of december
		if (state.selectedWeek == 52 && moment().year(state.selectedYear).isoWeeksInYear() == 52) {
			console.log("%c" + `In week 52 - only 52 weeks this selected year.`, "background: #222; color: #bada55")
			end = moment().year(state.selectedYear).endOf("year").endOf("day").unix()
			state.endWeek = end
			state.endDayName = moment.unix(end).format("dddd")
		}
		state.startWeek = start
		state.endWeek = end
		state.startYear = moment.unix(start).startOf("year").unix()
		state.priorStartWeek = moment.unix(start).subtract(365, "days").subtract(7, "days").unix()
		state.priorEndWeek = moment.unix(end).subtract(365, "days").unix()
		this.setState(state, () => {
			this.getData()
		})
	}

	developerSkip = (v) => {
		try {
			if (this.state.active === `developer-null` && v.property_developer) {
				// regular developer jdc
				return true
			} else if (
				this.state.active !== "developer-null" &&
				typeof this.state.active == "string" &&
				this.state.active.includes("developer-")
			) {
				let split = this.state.active.split("-")
				if (split[1] !== v.property_developer) return true
			}
		} catch (e) {
			console.log(e)
		}
		return false
	}

	changeReport = () => {
		let sales = []
		let closings = []
		let bustouts = []
		let starts = []
		let traffic = []
		let traffic_grouped = []
		let allSales = []
		let allBusts = []
		let propertyBreakout = {}
		let propertyModel = {
			sales: [],
			bustouts: [],
			closings: [],
			starts: [],
			traffic: [],
			traffic_grouped: [],
		}
		_.forEach(this.state.payload.sales.allSales, (v) => {
			if (this.developerSkip(v)) return
			let active = this.state.active
			if (typeof active === "number" && v.metro_group !== active) return
			allSales.push(v)
			if (v[this.sale_date] >= this.state.startWeek && v[this.sale_date] < this.state.endWeek) {
				let active = this.state.active
				if (typeof active === "number" && v.metro_group !== active) return
				sales.push(v)
				if (!_.has(propertyBreakout, v.property)) {
					propertyBreakout[v.property] = _.cloneDeep(propertyModel)
				}
				propertyBreakout[v.property].sales.push(v)
			}
		})
		// Loop through all busts instead of allsales, because some super old sales wouldn't be in allSales as that only goes back to beginning of previous year.  Some busts are sales from 2020, but cancelled in 2022, thus it's missing.
		_.forEach(this.state.payload.bustouts.allBusts, (v) => {
			if (this.developerSkip(v)) return
			if (v[this.bustout_date] >= this.state.startWeek && v[this.bustout_date] < this.state.endWeek) {
				let active = this.state.active
				if (typeof active === "number" && v.metro_group !== active) return
				bustouts.push(v)
				if (!_.has(propertyBreakout, v.property)) {
					propertyBreakout[v.property] = _.cloneDeep(propertyModel)
				}
				propertyBreakout[v.property].bustouts.push(v)
			}
			if (v[this.bustout_date]) {
				if (this.state.active !== "all" && v.metro_group !== this.state.active) {
					return
				}
				allBusts.push(v)
			}
		})
		_.forEach(this.state.payload.closings.allClosings, (v) => {
			if (v[this.closing_date] >= this.state.startWeek && v[this.closing_date] < this.state.endWeek) {
				if (this.developerSkip(v)) return
				if (this.state.active !== "all") {
					// has a metro
					if (v.metro_group !== this.state.active) {
						return
					}
				}
				closings.push(v)
				if (!_.has(propertyBreakout, v.property)) {
					propertyBreakout[v.property] = _.cloneDeep(propertyModel)
				}
				propertyBreakout[v.property].closings.push(v)
			}
		})
		_.forEach(this.state.payload.starts.current, (v) => {
			if (this.developerSkip(v)) return
			let active = this.state.active
			if (typeof active === "number" && v.metro_group !== active) return
			starts.push(v)
			if (!_.has(propertyBreakout, v.property)) {
				propertyBreakout[v.property] = _.cloneDeep(propertyModel)
			}
			propertyBreakout[v.property].starts.push(v)
		})
		_.forEach(this.state.payload.traffic, (v) => {
			if (this.developerSkip(v)) return
			let active = this.state.active
			if (typeof active === "number" && v.metro_group !== active) return
			traffic.push(v)
			if (!_.has(propertyBreakout, v.property)) {
				propertyBreakout[v.property] = _.cloneDeep(propertyModel)
			}
			propertyBreakout[v.property].traffic.push(v)
		})
		_.forEach(this.state.payload.traffic_grouped, (v) => {
			if (this.developerSkip(v)) return
			let active = this.state.active
			if (typeof active === "number" && v.metro_group !== active) return
			traffic_grouped.push(v)
			if (!_.has(propertyBreakout, v.property)) {
				propertyBreakout[v.property] = _.cloneDeep(propertyModel)
			}
			propertyBreakout[v.property].traffic_grouped.push(v)
		})
		let quick = this.quickStats(
			sales.length,
			bustouts.length,
			closings.length,
			starts.length,
			traffic.length,
			traffic_grouped,
			this.state.active
		)
		this.setState(
			{
				active: this.state.active,
				sales: sales,
				bustouts: bustouts,
				closings: closings,
				weeklyTotals: quick,
				propertyBreakout,
				allSales,
				allBusts,
				weeklyWebUsers: _.get(this.state, `payload.weeklyWebUsers.usersTotal`),
				weeklyWebSessions: _.get(this.state, `payload.weeklyWebUsers.sessions`),
				brokenOutWebUsers: _.get(this.state, `payload.weeklyWebUsers`),
			},
			() => {
				//console.log(this.state)
			}
		)
	}

	realtorPercent = () => {
		let count = 0
		let total = 0
		let percent = 0
		for (let v of this.state.sales) {
			if (v.transfer_date || v.cancel_date || (v[this.bustout_date] && !settings.realtorGross)) {
				// Shouldn't have any bustouts as they'd have to sell and cancel in the same week, but just leave it in.
				continue
			}
			if (settings?.noRealtorTracking?.includes(v.property)) {
				continue
			}
			if (v.realtor_involved === 1) {
				count++
			}
			total++
		}
		percent = count / total
		if (!isFinite(percent)) {
			percent = 0
		}
		percent = percent.toFixed(2)
		percent = Math.round(parseFloat(percent) * 100)

		return (
			<div className="gauge">
				<Chart
					options={helpers.gaugeOptions("Realtor Sales")}
					series={[percent]}
					type="radialBar"
					width={"100%"}
				/>
			</div>
		)
	}

	bustRate = () => {
		let percent = this.state.weeklyTotals.busts / this.state.weeklyTotals.gross
		if (!isFinite(percent)) {
			percent = 0
		}
		percent = percent.toFixed(2)
		percent = Math.round(parseFloat(percent) * 100)
		return (
			<div className="gauge">
				<Chart
					options={helpers.gaugeOptions("Cancel Rate")}
					series={[percent]}
					type="radialBar"
					width={"100%"}
				/>
			</div>
		)
	}

	ytdRealtorPercent = () => {
		if (this.state.allSales.length == 0) {
			return
		}
		let count = 0
		let total = 0
		let percent = 0
		for (let v of this.state.allSales) {
			if (settings?.noRealtorTracking?.includes(v.property) || (v[this.bustout_date] && !settings.realtorGross)) {
				continue
			}
			if (v[this.sale_date] >= this.state.endWeek || v[this.sale_date] <= this.state.startYear) continue
			let year = parseInt(moment.unix(v[this.sale_date]).format("YYYY"))
			if (year !== this.state.selectedYear) {
				continue
			}
			if (this.state.active !== "all") {
				if (v.metro_group !== this.state.active) {
					continue
				}
			}
			if (v.realtor_involved === 1) {
				count++
			}
			total++
		}

		percent = count / total
		if (!isFinite(percent)) {
			percent = 0
		}
		percent = percent.toFixed(2)
		percent = Math.round(parseFloat(percent) * 100)

		return (
			<div className="gauge">
				<Chart
					options={helpers.gaugeOptions("Realtor Sales")}
					series={[percent]}
					type="radialBar"
					width={"100%"}
				/>
			</div>
		)
	}

	ytdBustRate = () => {
		if (this.state.allSales.length == 0) {
			return
		}
		let sales = _.filter(this.state.allSales, (r) => {
			let year = parseInt(moment.unix(r.sale_date).format("YYYY"))
			if (year == this.state.selectedYear && r.sale_date <= this.state.endWeek) {
				return true
			}
		})
		let busts = _.filter(this.state.allBusts, (r) => {
			let year = parseInt(moment.unix(r.bustout_date).format("YYYY"))
			if (year == this.state.selectedYear && r.bustout_date <= this.state.endWeek) {
				return true
			}
		})
		let percent = busts.length / sales.length

		if (!isFinite(percent)) {
			percent = 0
		}
		percent = percent.toFixed(2)
		percent = Math.round(parseFloat(percent) * 100)
		return (
			<div className="gauge">
				<Chart
					options={helpers.gaugeOptions("Cancel Rate")}
					series={[percent]}
					type="radialBar"
					width={"100%"}
				/>
			</div>
		)
	}

	quickStats = (gross, busts, closings, starts, traffic, traffic_grouped, id) => {
		// Weekly based
		let net = gross - busts
		let tgrouped = 0
		_.forEach(traffic_grouped, (v) => {
			tgrouped += v.prospect_count
			tgrouped += v.realtor_count
		})
		let t = traffic + tgrouped

		return {
			gross,
			busts,
			closings,
			starts,
			traffic: t,
			net,
		}
	}

	lotTypes = () => {
		// First compile a list of all types
		let t = []
		for (let v of this.state.sales) {
			t.push(v.lot_type)
		}
		t = _.uniq(t)
		let types = {}
		for (let v of t) {
			let type = _.find(this.props.payload.public.lot_types, { id: v })
			if (type) {
				types[type.name] = 0
			}
		}

		for (let v of this.state.sales) {
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (type) {
				types[type.name]++
			}
		}
		let d = []
		_.forEach(types, (v, k) => {
			d.push({ key: k, val: v })
		})
		d = _.sortBy(d, "val").reverse().slice(0, 12)

		const data = {
			labels: _.map(d, (r) => r.key),
			datasets: [
				{
					data: _.map(d, (r) => r.val),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return <Pie data={data} options={opts} />
	}

	builderSales = () => {
		var [dataArray, labels, sorted, labelBuilders, dataSorted] = [{}, [], [], [], []]
		_.forEach(this.state.sales, (v) => {
			if (!v.builder) {
				return
			}
			if (v.builder in dataArray) {
				dataArray[v.builder]++
			} else {
				dataArray[v.builder] = 1
			}
		})
		for (var prop in dataArray) {
			sorted.push([prop, dataArray[prop]])
		}

		sorted.sort(function (a, b) {
			return a[1] - b[1]
		})
		sorted = sorted.reverse()
		_.forEach(sorted, (v) => {
			labelBuilders.push(v[0])
			dataSorted.push(v[1])
		})
		_.forEach(labelBuilders, (v) => {
			let b = _.find(this.props.payload.public.builders, {
				id: parseInt(v),
			})
			labels.push(`${b.name}`)
		})
		const opts = {
			layout: {
				padding: {
					right: 50,
				},
			},
			plugins: {
				datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
							userCallback: function (label) {
								if (Math.floor(label) === label) {
									return label
								}
							},
						},
					},
				],
			},
		}

		labels = labels.slice(0, limit)
		dataSorted = dataSorted.slice(0, limit)

		const data = {
			labels: labels,
			datasets: [
				{
					label: "Sales ",
					backgroundColor: "#30576c",
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: dataSorted,
				},
			],
		}

		return <HorizontalBar data={data} options={opts} />
	}

	salesBySalespeople = () => {
		var [dataArray, labels, sorted, labelSalespeople, dataSorted] = [{}, [], [], [], []]
		_.forEach(this.state.sales, (v) => {
			if (!v.salesperson) {
				return
			}
			if (v.salesperson in dataArray) {
				dataArray[v.salesperson]++
			} else {
				dataArray[v.salesperson] = 1
			}
		})

		for (var prop in dataArray) {
			sorted.push([prop, dataArray[prop]])
		}
		sorted.sort(function (a, b) {
			return a[1] - b[1]
		})
		sorted = sorted.reverse()
		_.forEach(sorted, (v) => {
			labelSalespeople.push(v[0])
			dataSorted.push(v[1])
		})
		_.forEach(labelSalespeople, (v) => {
			let sp = _.find(this.props.payload.public.salespeople, {
				id: parseInt(v),
			})
			if (sp) {
				labels.push(`${sp.first} ${sp.last}`)
			}
		})
		const opts = {
			layout: {
				padding: {
					right: 50,
				},
			},
			plugins: {
				datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
							userCallback: function (label) {
								if (Math.floor(label) === label) {
									return label
								}
							},
						},
					},
				],
			},
		}
		labels = labels.slice(0, limit)
		dataSorted = dataSorted.slice(0, limit)
		const data = {
			labels: labels,
			datasets: [
				{
					label: "Sales ",
					backgroundColor: "#30576c",
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: dataSorted,
				},
			],
		}

		return <HorizontalBar data={data} options={opts} />
	}

	trafficSources = () => {
		// Need to count traffic and sale sources, traffic should come in the payload
		var [labels, dataArray, sorted, f] = [[], {}, [], []]
		_.forEach(this.state.sales, (v) => {
			if (!v.traffic_source) {
				return
			}
			if (v.traffic_source in dataArray) {
				dataArray[v.traffic_source]++
			} else {
				dataArray[v.traffic_source] = 1
			}
		})
		_.forEach(this.props.payload.traffic.split, (v, k) => {
			if (k in dataArray) {
				dataArray[k] += v
			} else {
				dataArray[k] = v
			}
		})
		for (var source in dataArray) {
			sorted.push([source, dataArray[source]])
		}
		sorted
			.sort(function (a, b) {
				return a[1] - b[1]
			})
			.reverse()
		_.forEach(sorted, (v) => {
			if (v[0] !== "0") {
				f.push(v[1])
				let b = _.find(this.props.payload.public.trafficSources, {
					id: parseInt(v),
				})
				labels.push(`${b.name}`)
			}
		})
		labels = labels.slice(0, limit)
		f = f.slice(0, limit)
		const data = {
			labels: labels,
			datasets: [
				{
					label: "Sold",
					backgroundColor: "#30576c",
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: f,
				},
			],
		}

		const opts = {
			layout: {
				padding: {
					right: 50,
				},
			},
			plugins: {
				datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
			},
			scales: {
				xAxes: [
					{
						stacked: true,
					},
				],
				yAxes: [
					{
						stacked: true,
					},
				],
			},
		}

		return <HorizontalBar data={data} options={opts} />
	}

	floorplans = () => {
		var [labels, floorplans, sorted, labelFloorplans, dataSorted] = [[], [], [], [], []]
		_.forEach(this.state.sales, (v, k) => {
			if (!v.floorplan) {
				return
			}
			//var floorplanName = this.props.payload.floorplans[v.floorplan]
			if (v.floorplan in floorplans) {
				floorplans[v.floorplan]++
			} else {
				floorplans[v.floorplan] = 1
			}
		})
		for (var prop in floorplans) {
			sorted.push([prop, floorplans[prop]])
		}

		sorted.sort(function (a, b) {
			return a[1] - b[1]
		})
		sorted = sorted.reverse().slice(0, limit)
		_.forEach(sorted, (v) => {
			labelFloorplans.push(v[0])
			dataSorted.push(v[1])
		})
		_.forEach(labelFloorplans, (v) => {
			v = parseInt(v)
			if (isNaN(v)) {
				return
			}
			let b = _.find(this.props.payload.public.floorplans, {
				id: parseInt(v),
			})
			if (b) {
				labels.push(`${b.name}`)
			}

			//labels.push(this.props.payload.public.floorplans[v])
		})
		labels = labels.slice(0, limit)
		dataSorted = dataSorted.slice(0, limit)
		const data = {
			labels: labels,
			datasets: [
				{
					label: "Sales",
					backgroundColor: "#30576c",
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: dataSorted,
				},
			],
		}

		const opts = {
			layout: {
				padding: {
					right: 50,
				},
			},
			plugins: {
				datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
			},
			scales: {
				xAxes: [
					{
						stacked: true,
						ticks: {
							beginAtZero: true,
							userCallback: function (label) {
								if (Math.floor(label) === label) {
									return label
								}
							},
						},
					},
				],
				yAxes: [
					{
						stacked: true,
					},
				],
			},
		}

		return <HorizontalBar data={data} options={opts} />
	}

	salesMeter = () => {
		if (settings?.execSplitOutAnalysisBars) {
			let ret = []
			let sorted = _.sortBy(this.state.payload.communityPerformance, "name")
			_.forEach(sorted, (v, k) => {
				let current = v.thisYearSales - v.thisYearBusts
				let projected = v.current_projected
				let previous = v.net_previous_year
				let total = v.thisYearTotalProjected
				let currentPercent = (current / total) * 100
				let projectedPercent = (projected / total) * 100
				let previousPercent = (previous / total) * 100
				ret.push(
					<div className="my-10">
						<h3 className="statBox__title">{v.name}</h3>
						<div className="meter__cont">
							<div className="meter">
								<div className="meter__fill" style={{ width: currentPercent + "%" }}>
									<span>
										{current.toLocaleString()} Actual ({Math.round(currentPercent)}%)
									</span>
								</div>
								<div className="meter__projected" style={{ left: projectedPercent + "%" }}>
									<span>
										{projected.toLocaleString()} Projected ({Math.round(projectedPercent)}%)
									</span>
								</div>
								<div
									className="meter__previous"
									style={{ left: previousPercent > 100 ? "100%" : previousPercent + "%" }}>
									<span>
										{previous.toLocaleString()} Previous Year ({Math.round(previousPercent)}%)
									</span>
								</div>
							</div>
							<div className="meter__total">{total.toLocaleString()} Projected Annual Sales Goal</div>
						</div>
					</div>
				)
			})
			return ret
		} else {
			let projected = 0
			let total = 0
			let current = 0
			let previous = 0
			_.forEach(this.state.payload.communityPerformance, (v, k) => {
				if (this.developerSkip(v)) return
				let active = this.state.active
				if (typeof active === "number" && v.metro_group !== active) return
				current += v.thisYearSales - v.thisYearBusts
				projected += v.current_projected
				previous += v.net_previous_year
				total += v.thisYearTotalProjected
			})
			let currentPercent = (current / total) * 100
			let projectedPercent = (projected / total) * 100
			let previousPercent = (previous / total) * 100
			return (
				<div>
					<h3 className="statBox__title mb-4">Home Sales Analysis YTD</h3>
					<div className="meter__cont">
						<div className="meter">
							<div className="meter__fill" style={{ width: currentPercent + "%" }}>
								<span>
									{current.toLocaleString()} Actual ({Math.round(currentPercent)}%)
								</span>
							</div>
							<div className="meter__projected" style={{ left: projectedPercent + "%" }}>
								<span>
									{projected.toLocaleString()} Projected ({Math.round(projectedPercent)}%)
								</span>
							</div>
							<div
								className="meter__previous"
								style={{ left: previousPercent > 100 ? "100%" : previousPercent + "%" }}>
								<span>
									{previous.toLocaleString()} Previous Year ({Math.round(previousPercent)}%)
								</span>
							</div>
						</div>
						<div className="meter__total">{total.toLocaleString()} Projected Annual Sales Goal</div>
					</div>
				</div>
			)
		}
	}

	cumulativeSales = () => {
		let year = this.state.selectedYear
		let years = [year - 1, year]
		let ret = {
			[`${year} Net`]: [],
			[`${year - 1} Net`]: [],
			[`${year} Projected`]: [],
		}

		let labels = _.range(1, 53)
		_.forEach(years, (y) => {
			if (_.has(this.state.payload, `allSalesTotalsByWeek.${y}`)) {
				_.forEach(this.state.payload.allSalesTotalsByWeek[y], (r) => {
					let last = _.last(ret[[`${y} Net`]]) || 0
					let active = this.state.active
					if (typeof active === "string" && active.includes("developer-")) {
						let split = active.split("-")
						if (split[1] === "null") split[1] = "defaultDeveloper"
						ret[[`${y} Net`]].push(last + r.developers[split[1]].net)
					} else if (active === "all") {
						ret[[`${y} Net`]].push(last + r.net)
					} else {
						ret[[`${y} Net`]].push(last + r.metros[active].net)
					}
					if (year == y) {
						// current year for projections
						let last = _.last(ret[[`${y} Projected`]]) || 0
						if (typeof active === "string" && active.includes("developer-")) {
							let split = active.split("-")
							if (split[1] === "null") split[1] = "defaultDeveloper"
							ret[[`${y} Projected`]].push(r.developers[split[1]].projected + last)
						} else if (active == "all") {
							ret[[`${y} Projected`]].push(r.projected + last)
						} else {
							ret[[`${y} Projected`]].push(r.metros[active].projected + last)
						}
					}
				})
			}
		})
		// If viewing current year, chop off the weeks in the future
		if (year == moment().year()) {
			let currentWeek = moment().isoWeek()
			ret[`${year} Net`].length = currentWeek - 1
		}
		let opts = {
			tooltips: {
				enabled: false,
			},
			legend: {
				display: true,
				position: "bottom",
			},
			scales: {
				xAxes: [
					{
						ticks: {
							//beginAtZero: true,
						},
					},
				],
			},
			plugins: {
				datalabels: { display: false },
			},
		}
		const data = {
			labels: labels,
			datasets: [
				{
					label: [year + " Net"],
					data: ret[[year + " Net"]],
					borderColor: "#5A9BD4",
					backgroundColor: "#5A9BD4",
					fill: false,
				},
				{
					label: [year - 1 + " Net"],
					data: ret[[year - 1 + " Net"]],

					borderColor: "#F57A27",
					backgroundColor: "#F57A27",
					fill: false,
				},
			],
		}
		if (_.sum(ret[`${year} Projected`]) > 0) {
			data.datasets.push({
				label: [year + " Projected"],
				data: ret[[year + " Projected"]],
				borderColor: "#5A9BD4",
				backgroundColor: "#5A9BD4",
				fill: false,
				borderDash: [5, 5],
			})
		}
		return <Line data={data} options={opts} />
	}

	inventoryStatus = () => {
		// First compile a list of all statuses
		let statuses = {
			"Pending Sale": 0,
			"Sales Opportunities": 0,
		}
		let count = 0
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (this.state.active !== "all") {
				let prop = _.find(this.props.payload.public.properties, { id: v.property })
				if (prop && prop.metro_group !== this.state.active) {
					return
				}
			}
			if (v[this.closing_date]) {
				return
			}
			if (v.sale_id) {
				// active sale - can use just sale_id because if it were closed it would have gotten caught before this
				statuses["Pending Sale"]++
			} else {
				statuses["Sales Opportunities"]++
			}
			count++
		})

		const data = {
			labels: _.keys(statuses),
			datasets: [
				{
					data: _.values(statuses),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return (
			<>
				<h3 className="statBox__title" style={{ marginBottom: "5px" }}>
					Contract and Lot Status
				</h3>
				<p style={{ margin: 0, fontSize: "14px" }}>Total Lots: {count.toLocaleString()}</p>
				<Pie data={data} options={opts} />
			</>
		)
	}

	salesOpportunities = () => {
		// First compile a list of all statuses
		let statuses = {
			"Specs Under Construction": 0,
			"Vacant Delivered": 0,
			"Vacant Pending": 0,
			"Completed Specs": 0,
			Models: 0,
		}
		let bucket = this.state.active
		let active = this.state.active
		if (active === "developer-null") bucket = "defaultDeveloper"
		else if (typeof active === "string" && active.includes("developer-")) {
			let split = active.split("-")
			bucket = split[1]
		}
		let d = _.values(this.state.payload.exec.salesOpportunities[bucket])

		const data = {
			labels: _.keys(statuses),
			datasets: [
				{
					data: d,
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return (
			<>
				<h3 className="statBox__title" style={{ marginBottom: "5px" }}>
					Sales Opportunity Breakdown
				</h3>
				<p style={{ margin: 0, fontSize: "14px" }}>
					Total Lots: {this.state.payload.exec.salesOpportunities.count.toLocaleString()}
				</p>
				<Pie data={data} options={opts} />
			</>
		)
	}

	builderVacantLots = () => {
		// First compile a list of all statuses
		let statuses = {
			"Builder Owned": 0,
			"Developer Owned - Delivered": 0,
			"Developer Owned - Pending": 0,
			"Developer Owned Unassigned to Builder": 0,
		}
		let bucket = this.state.active
		let active = this.state.active
		if (active === "developer-null") bucket = "defaultDeveloper"
		else if (typeof active === "string" && active.includes("developer-")) {
			let split = active.split("-")
			bucket = split[1]
		}
		let d = _.values(this.state.payload.exec.vacantLotInventory[bucket])

		const data = {
			labels: _.keys(statuses),
			datasets: [
				{
					data: d,
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return <Pie data={data} options={opts} />
	}

	salesList = () => {
		let columns = [
			{
				Header: "Sales Person",
				accessor: "salesperson",
			},
			{
				Header: "Builder",
				accessor: "builder",
			},
			{
				Header: "Address",
				accessor: "address",
			},
			{
				Header: "Price",
				accessor: "price",
				Cell: (v) => {
					if (v.value) {
						return `$${v.value.toLocaleString()}`
					}
					return ""
				},
			},
			{
				Header: "Date",
				accessor: "date",
				Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
				sort: "desc",
			},
		]

		var ret = []

		for (let r of this.state.sales) {
			var v = {}
			let salesperson = ""
			if (r.salesperson) {
				let findsp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
				if (findsp) {
					salesperson = `${findsp.first} ${findsp.last}`
				}
			}
			let builder = ""
			let findBuilder = _.find(this.props.payload.public.builders, { id: r.builder })
			if (findBuilder) {
				builder = findBuilder.name
			}

			v.salesperson = salesperson
			v.address = r.address
			v.price = r.price
			v.builder = builder
			v.date = r.sale_date ? r.sale_date : r.addedDate

			ret.push(v)
		}

		ret = _.sortBy(ret, "date").reverse()

		return <ReactTable loadingText="" data={ret} columns={columns} defaultPageSize={10} />
	}

	bustoutList = () => {
		let columns = [
			{
				Header: "Sales Person",
				accessor: "salesperson",
			},
			{
				Header: "Builder",
				accessor: "builder",
			},
			{
				Header: "Address",
				accessor: "address",
			},
			{
				Header: "Price",
				accessor: "price",
				Cell: (v) => `$${v.value.toLocaleString()}`,
			},
			{
				Header: "Date",
				accessor: "date",
				Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
				sort: "desc",
			},
		]

		var ret = []

		for (let r of this.state.bustouts) {
			var v = {}
			let salesperson = ""
			if (r.salesperson) {
				let findsp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
				if (findsp) {
					salesperson = `${findsp.first} ${findsp.last}`
				}
			}
			let builder = ""
			let findBuilder = _.find(this.props.payload.public.builders, { id: r.builder })
			if (findBuilder) {
				builder = findBuilder.name
			}

			v.salesperson = salesperson
			v.address = r.address
			v.builder = builder
			v.price = r.price
			v.date = r.sale_date ? r.sale_date : r.addedDate

			ret.push(v)
		}

		ret = _.sortBy(ret, "date").reverse()

		return <ReactTable loadingText="" data={ret} columns={columns} defaultPageSize={10} />
	}

	closingList = () => {
		let columns = [
			{
				Header: "Sales Person",
				accessor: "salesperson",
			},
			{
				Header: "Builder",
				accessor: "builder",
			},
			{
				Header: "Address",
				accessor: "address",
			},
			{
				Header: "Price",
				accessor: "price",
				Cell: (v) => `$${v.value.toLocaleString()}`,
			},
			{
				Header: "Date",
				accessor: "date",
				Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
				sort: "desc",
			},
		]

		var ret = []

		for (let r of this.state.closings) {
			var v = {}
			let salesperson = ""
			if (r.salesperson) {
				let findsp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
				if (findsp) {
					salesperson = `${findsp.first} ${findsp.last}`
				}
			}
			let builder = ""
			let findBuilder = _.find(this.props.payload.public.builders, { id: r.builder })
			if (findBuilder) {
				builder = findBuilder.name
			}

			v.salesperson = salesperson
			v.address = r.address
			v.builder = builder
			v.price = r.price
			v.date = r.sale_date ? r.sale_date : r.addedDate

			ret.push(v)
		}

		ret = _.sortBy(ret, "date").reverse()

		return <ReactTable loadingText="" data={ret} columns={columns} defaultPageSize={10} />
	}

	salesTD = () => {
		// Last 2 years
		let ret = {}

		let current = 0
		let projected = 0
		let previous = 0
		_.forEach(this.state.payload.communityPerformance, (v, k) => {
			if (this.developerSkip(v)) return
			if (typeof this.state.active === "number" && v.metro_group !== this.state.active) return
			current += v.thisYearSales - v.thisYearBusts
			projected += v.current_projected
			previous += v.net_previous_year
		})
		ret = {
			"Previous YTD": previous,
			"Actual YTD": current,
			"Projected YTD": projected,
		}

		let percents = {
			avp: Math.round(percentChange(ret["Projected YTD"], ret["Actual YTD"])), // actual vs projected
			pvc: Math.round(percentChange(ret["Previous YTD"], ret["Actual YTD"])), // previous vs current
		}
		_.forEach(percents, (v, k) => {
			if (Math.sign(v) == 1) {
				percents[k] = <span className="darkGreen bold">{`+${v}%`}</span>
			} else if (Math.sign(v) == -1) {
				percents[k] = <span className="red bold">{`${v}%`}</span>
			}
		})
		let sorted = []
		let labels = []
		_.forEach(ret, (v, k) => {
			labels.push(k)
			sorted.push(v)
		})

		const opts = {
			layout: {
				padding: {
					right: 50,
				},
			},
			plugins: {
				datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
							userCallback: function (label) {
								if (Math.floor(label) === label) {
									return label
								}
							},
						},
					},
				],
			},
		}

		const data = {
			labels: labels,
			datasets: [
				{
					label: "NET Sales",
					backgroundColor: "#30576c",
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: sorted,
				},
			],
		}
		return (
			<>
				<HorizontalBar data={data} options={opts} />
				<p style={{ textAlign: "center", fontSize: "14px" }}>
					Actual vs. Previous YTD: {percents.pvc} | Actual vs. Projected YTD: {percents.avp}
				</p>
			</>
		)
	}

	communityPerformance = () => {
		let columns = [
			{
				Header: "Community",
				accessor: "community",
			},
			...(settings?.executiveReport?.communityPerformance?.showCounties
				? [{ Header: "County", accessor: "county" }]
				: []),
			{
				Header: "Weekly",
				columns: [
					{
						Header: "Gross Sales",
						accessor: "gross_sales",
						Footer: (props) => helpers.tableTotals(props, "gross_sales", "0,0"),
					},
					{
						Header: "Net Sales",
						accessor: "net_sales",
						Footer: (props) => helpers.tableTotals(props, "net_sales", "0,0"),
					},
					{
						Header: "Closings",
						accessor: "closings",
						Footer: (props) => helpers.tableTotals(props, "closings", "0,0"),
					},
					{
						Header: "Specs",
						accessor: "specs",
						Footer: (props) => helpers.tableTotals(props, "specs", "0,0"),
					},
					{
						Header: "Traffic",
						accessor: "traffic",
						Footer: (props) => helpers.tableTotals(props, "traffic", "0,0"),
					},
					{
						Header: "Cancellation Rate",
						accessor: "bust_rate",
						Cell: (v) => {
							/* if (v.value) {
								return `${v.value}%`
							} else if (v.value == 0) {
								return "0%"
							}
							return "" */
							if (v.value) {
								if (Math.sign(v.value) == 1) {
									return `${v.value}%`
								} else if (Math.sign(v.value) == -1) {
									return `-${v.value}%`
								}
							}
							return "0%"
						},
						Footer: (props) => {
							let percent = this.state.weeklyTotals.busts / this.state.weeklyTotals.gross
							percent = percent.toFixed(2)
							percent = parseFloat(percent)
							percent = Math.round(percent * 100)
							return percent + "%"
						},
					},
					{
						Header: "Average Sale Price",
						accessor: "avg_price",
						Cell: (v) => {
							if (v.value) {
								return `$${v.value.toLocaleString()}`
							}
							return "N/A"
						},
					},
				],
			},
			{
				Header: "",
				className: "ReactTable__gutter",
				maxWidth: 10,
				sortable: false,
			},
			{
				Header: "Year to Date NET",
				columns: [
					{
						Header: "Previous Year",
						accessor: "previous_year",
						Footer: (props) => {
							let total = 0
							_.forEach(props.data, (v) => {
								total += v.previous_year
							})
							if (typeof total == "number") {
								return total.toLocaleString()
							}
							return total
						},
					},
					{
						Header: "Projected YTD",
						accessor: "projected",
						Footer: (props) => {
							let total = 0
							_.forEach(props.data, (v) => {
								total += v.projected
							})
							if (typeof total == "number") {
								return total.toLocaleString()
							}
							return total
						},
					},
					{
						Header: "Net YTD",
						accessor: "actual",
						Footer: (props) => {
							let total = 0
							_.forEach(props.data, (v) => {
								total += v.actual
							})
							if (typeof total == "number") {
								return total.toLocaleString()
							}
							return total
						},
					},
					{
						Header: "Net/Projected Variance",
						accessor: "variance",
						Cell: (v) => {
							if (v.value) {
								if (Math.sign(v.value) == 1) {
									return (
										<span className="darkGreen bold">
											+{v.value} / {v.original.avp}
										</span>
									)
								} else if (Math.sign(v.value) == -1) {
									return (
										<span className="red bold">
											{v.value} / {v.original.avp}
										</span>
									)
								}
							}
							return "0 / 0%"
						},
						Footer: (props) => {
							let actual = 0
							let projected = 0
							_.forEach(props.data, (v) => {
								if (v.actual) actual += v.actual
								if (v.projected) projected += v.projected
							})
							let total = actual - projected
							let percent = Math.round(percentChange(projected, actual))
							if (Math.sign(total) == 1) {
								return (
									<span className="darkGreen bold">
										+{total} / +{percent}%
									</span>
								)
							} else if (Math.sign(total) == -1) {
								return (
									<span className="red bold">
										{total} / {percent}%
									</span>
								)
							} else {
								return 0
							}
						},
					},
					{
						Header: "YoY Variance",
						accessor: "yoy_variance",
						Cell: (v) => {
							if (Math.sign(v.value) == 1) {
								return (
									<span className="darkGreen bold">
										+{v.value} / {v.original.pvc}
									</span>
								)
							} else if (Math.sign(v.value) == -1) {
								return (
									<span className="red bold">
										{v.value} / {v.original.pvc}
									</span>
								)
							}
							return "0 / 0%"
						},
						Footer: (props) => {
							let lastYear = 0
							let thisYear = 0
							_.forEach(props.data, (v) => {
								if (v.actual) thisYear += v.actual
								if (v.previous_year) lastYear += v.previous_year
							})
							let total = thisYear - lastYear
							let percent = Math.round(percentChange(lastYear, thisYear))
							if (Math.sign(total) == 1) {
								return (
									<span className="darkGreen bold">
										+{total} / +{percent}%
									</span>
								)
							} else if (Math.sign(total) == -1) {
								return (
									<span className="red bold">
										{total} / {percent}%
									</span>
								)
							} else {
								return 0
							}
						},
					},
				],
			},
		]
		var ret = []
		let count = 0
		_.forEach(this.state.payload.communityPerformance, (r, k) => {
			if (!r.property_active) return
			k = parseInt(k)
			if (this.developerSkip(r)) return
			let active = this.state.active
			if (typeof active === "number" && r.metro_group !== active) return
			let v = {}

			let property = _.find(this.props.payload.public.properties, { id: k })
			if (!property) {
				return
			}
			if (property && property.in_weekly_report === 0) {
				return
			}
			let county
			if (property?.county) {
				let countyLookup = _.find(this.props.payload.public.counties, { id: property.county })
				if (countyLookup) {
					county = countyLookup.name
				}
			}
			v.community = property.name
			v.county = county
			v.gross_sales = r.weekly_gross
			v.net_sales = r.weekly_net
			v.closings = r.weekly_closings
			v.traffic = r.weekly_traffic
			v.specs = r.specs
			v.bust_rate = r.weekly_bust_rate
			v.variance = r.variance
			v.yoy_variance = r.yoy_variance
			v.previous_year = r.net_previous_year
			v.actual = r.net_current_actual
			v.projected = r.current_projected
			v.avg_price = r.avg_price
			v.avp = Math.round(percentChange(v.projected, v.actual))
			v.pvc = Math.round(percentChange(v.previous_year, v.actual))
			if (isNaN(v.avp) || !isFinite(v.avp)) {
				v.avp = 0
			}
			if (isNaN(v.pvc) || !isFinite(v.pvc)) {
				v.pvc = 0
			}
			if (Math.sign(v.avp) === 1) {
				v.avp = <span className="darkGreen bold">{`+${v.avp}%`}</span>
			} else if (Math.sign(v.avp) === -1) {
				v.avp = <span className="red bold">{`${v.avp}%`}</span>
			} else {
				v.avp = `0%`
			}

			if (Math.sign(v.pvc) === 1) {
				v.pvc = <span className="darkGreen bold">{`+${v.pvc}%`}</span>
			} else if (Math.sign(v.pvc) === -1) {
				v.pvc = <span className="red bold">{`${v.pvc}%`}</span>
			} else {
				v.pvc = `0%`
			}
			ret.push(v)
			count++
		})
		//ret = _.sortBy(ret, "date").reverse()
		return (
			<>
				<ReactTable
					data={ret}
					columns={columns}
					loadingText=""
					defaultPageSize={count}
					defaultSorted={[
						{
							id: "gross_sales",
							desc: true,
						},
						{
							id: "community",
							asc: true,
						},
					]}
				/>
			</>
		)
	}

	salesVariance = () => {
		let ret = {
			"Previous Year": [],
			"Projected WTD": [],
			"Net WTD": [],
		}

		let labels = []
		let sorted = _.sortBy(this.state.payload.communityPerformance, "name")
		sorted = _.filter(sorted, (v) => v.property_active)
		_.forEach(sorted, (v, k) => {
			if (this.developerSkip(v)) return
			let active = this.state.active
			if (typeof active === "number" && v.metro_group !== active) return
			let property = _.find(this.props.payload.public.properties, { id: v.id })
			if (!property || property.in_weekly_report === 0) {
				return
			}
			labels.push(property.name)
			ret["Previous Year"].push(v.last_weekly_net)
			ret["Projected WTD"].push(v.weekly_projected)
			ret["Net WTD"].push(v.weekly_net)
		})
		let opts = {
			legend: {
				display: true,
				position: "bottom",
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
						},
					},
				],
				yAxes: [
					{
						ticks: {
							beginAtZero: true,
						},
					},
				],
			},
		}

		const data = {
			labels: labels,
			datasets: [
				{
					label: "Previous Year Week " + this.state.selectedWeek,
					backgroundColor: "#C297F5",
					type: "line",
					fill: false,
					pointRadius: 10,
					pointHoverRadius: 10,
					borderColor: "#8f6fb5",
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: ret["Previous Year"],
				},
				{
					label: "Net Week " + this.state.selectedWeek,
					backgroundColor: "#ace07e",
					borderColor: "#ace07e",
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: ret["Net WTD"],
				},
			],
		}
		if (!settings.disabled.projections) {
			data.datasets.push({
				label: "Projected Week " + this.state.times.curWeek,
				backgroundColor: "#3295EC",
				borderColor: "#3295EC",
				borderWidth: 1,
				hoverBackgroundColor: "rgba(50,149,236,0.5)",
				hoverBorderColor: "rgba(50,149,236,0.9)",
				data: ret["Projected WTD"],
			})
		}
		//
		return <Bar data={data} options={opts} />
	}

	metros = () => {
		let ret = [
			{
				value: "all",
				label: "Company Wide",
			},
		]
		if (_.get(settings, `execDeveloperSplit`)) {
			_.forEach(settings.execDeveloperSplit, (v) => {
				ret.push({
					value: `developer-${v.id}`,
					label: v.name,
				})
			})
		}
		_.forEach(this.props.payload.public.metro, (v) => {
			if (v.show == 1) {
				ret.push({
					value: v.id,
					label: v.name,
				})
			}
		})

		return ret
	}

	years = () => {
		let year = this.state.times.year
		let b = year - 1
		let ret = []
		while (b <= year) {
			ret.push({
				value: b,
				label: b,
			})
			b++
		}
		//ret.push({value: 2025, label: 2025})
		ret = _.reverse(ret)
		return ret
	}

	weeks = () => {
		let ret = []
		let i = 0
		while (i <= 53) {
			ret.push({
				value: i,
				label: i,
			})
			i++
		}

		return ret
	}

	changeReportType = (v) => {
		let state = _.cloneDeep(this.state)
		state.active = v.value
		state.options.active = v

		this.setState(state, () => {
			this.changeReport()
		})
	}

	outputCommunityPerformance = (pos) => {
		if (settings.execCommunityPerformanceUpTop && pos === "bottom") return null
		else if (!settings.execCommunityPerformanceUpTop && pos === "top") return null
		return (
			<div className="imageGroup">
				<div className="statBox__row">
					<div className="statBox__row">
						<div className="statBox__box">
							<h3 className="statBox__title">Community Performance</h3>
							{this.communityPerformance()}
						</div>
					</div>
				</div>
			</div>
		)
	}

	outputSalesAnalysis = (pos) => {
		if (settings.execAnalysisBarUpTop && pos === "bottom") return null
		else if (!settings.execAnalysisBarUpTop && pos === "top") return null

		return (
			<>
				{!_.get(settings, `weekly.restrictSalesMeter`) ? (
					<div className="statBox__row">
						<div className="statBox__box">{this.salesMeter()}</div>
					</div>
				) : (
					""
				)}
			</>
		)
	}

	outputQuickStats = () => {
		if (settings?.execSplitOutStats) {
			// split stats out by property.  If false default to combinging everyones stats
			let ret = []
			if (!_.isEmpty(this.state.propertyBreakout)) {
				// Sort by property name first
				_.forEach(this.state.propertyBreakout, (v, k) => {
					let property = _.find(this.props.payload.public.properties, { id: parseInt(k) })
					v.property = property?.name
				})
				let sorted = _.sortBy(this.state.propertyBreakout, "property")
				_.forEach(sorted, (v, k) => {
					let stats = this.quickStats(
						v.sales.length,
						v.bustouts.length,
						v.closings.length,
						v.starts.length,
						v.traffic.length,
						v.traffic_grouped.length
					)
					let webUsers = _.get(this.state.brokenOutWebUsers, k + 1)?.users
					ret.push(
						<div key={`quickstats-${v?.property}`}>
							<div className="quickStats py-5">
								<div className="mx-auto w-[90%]">
									<h2 className="text-white pt-0 border-b-0">{v?.property}</h2>
								</div>
								<ul className="quickStats__list">
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">{stats.gross}</div>
											<div className="quickStats__type">Gross Sales</div>
										</div>
									</li>
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">{stats.net}</div>
											<div className="quickStats__type">Net Sales</div>
										</div>
									</li>
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">{stats.busts}</div>
											<div className="quickStats__type">Cancellations</div>
										</div>
									</li>
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">{stats.closings}</div>
											<div className="quickStats__type">Closings</div>
										</div>
									</li>
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">{stats.starts}</div>
											<div className="quickStats__type">Starts</div>
										</div>
									</li>
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">{stats.traffic}</div>
											<div className="quickStats__type">Traffic</div>
										</div>
									</li>
									{webUsers && this.state.active === "all" ? (
										<li className="quickStats__item">
											<div>
												<div className="quickStats__stat">
													{numeral(webUsers).format("0,0")}
												</div>
												<div className="quickStats__type">Web Users</div>
											</div>
										</li>
									) : null}
								</ul>
							</div>
						</div>
					)
				})
			}
			if (ret.length) return ret
		}
		return (
			<div className="quickStats">
				<ul className="quickStats__list">
					<li className="quickStats__item">
						<div>
							<div className="quickStats__stat">{this.state.weeklyTotals.gross}</div>
							<div className="quickStats__type">Gross Sales</div>
						</div>
					</li>
					<li className="quickStats__item">
						<div>
							<div className="quickStats__stat">{this.state.weeklyTotals.net}</div>
							<div className="quickStats__type">Net Sales</div>
						</div>
					</li>
					<li className="quickStats__item">
						<div>
							<div className="quickStats__stat">{this.state.weeklyTotals.busts}</div>
							<div className="quickStats__type">Cancellations</div>
						</div>
					</li>
					<li className="quickStats__item">
						<div>
							<div className="quickStats__stat">{this.state.weeklyTotals.closings}</div>
							<div className="quickStats__type">Closings</div>
						</div>
					</li>
					<li className="quickStats__item">
						<div>
							<div className="quickStats__stat">{this.state.weeklyTotals.starts}</div>
							<div className="quickStats__type">Starts</div>
						</div>
					</li>
					<li className="quickStats__item">
						<div>
							<div className="quickStats__stat">{this.state.weeklyTotals.traffic}</div>
							<div className="quickStats__type">Traffic</div>
						</div>
					</li>
					{this.state.weeklyWebUsers && this.state.active === "all" ? (
						<li className="quickStats__item">
							<div>
								<div className="quickStats__stat">
									{numeral(this.state.weeklyWebUsers).format("0,0")}
								</div>
								<div className="quickStats__type">Web Users</div>
							</div>
						</li>
					) : null}
					{this.state.weeklyWebSessions && this.state.active === "all" ? (
						<li className="quickStats__item">
							<div>
								<div className="quickStats__stat">
									{numeral(this.state.weeklyWebSessions).format("0,0")}
								</div>
								<div className="quickStats__type">Web Sessions</div>
							</div>
						</li>
					) : null}
				</ul>
			</div>
		)
	}

	render() {
		if (this.state.invalid) {
			return <Redirect to={"/login"} />
		} else if (!this.state.payloadStatus) {
			return (
				<div>
					<Overlay />
					<LoadingOverlay />
				</div>
			)
		} else {
			if (_.get(settings, `renderOverrides.executive`)) {
				return <RenderOverride name={`${settings.renderOverrides.executive}`} {...this} internal={true} />
			}
			// Default return
			return (
				<div className="executive">
					<div className="imageGroup">
						<Title title={`${this.state.name}`} showDate={false} cutPadding={true} />
						<div className="twoCol">
							<p className="content weekly__date">
								Week {this.state.selectedWeek} | {this.state.startDayName || "Monday"}{" "}
								{moment.unix(this.state.startWeek).format("MMMM D") + " "}-{" "}
								{this.state.endDayName || "Sunday"} {moment.unix(this.state.endWeek).format("MMMM D")}
							</p>
							<div className="weekly__yearsSelects">
								<div className="weekly__optionBox">
									<p>Report:</p>
									<ReactSelect
										name={`active`}
										className="reactSelect"
										options={this.metros()}
										value={this.state.options.active}
										onChange={(v) => this.changeReportType(v)}
										onBlur={() => {}}
									/>
								</div>
								<div className="weekly__optionBox">
									<p>Year:</p>
									<ReactSelect
										name={`metro`}
										className="reactSelect"
										options={this.years()}
										value={this.state.options.year}
										onChange={(v) => this.changeTime(v, "year")}
										onBlur={() => {}}
									/>
								</div>
								<div className="weekly__optionBox">
									<p>Week:</p>
									<ReactSelect
										name={`week`}
										className="reactSelect"
										options={this.weeks()}
										value={this.state.options.week}
										onChange={(v) => this.changeTime(v, "week")}
										onBlur={() => {}}
									/>
								</div>
							</div>
						</div>
						<div className="content">{this.outputCommunityPerformance("top")}</div>
						{this.outputQuickStats()}
						<div className="content">{this.outputSalesAnalysis("top")}</div>
						<div className="statBox">
							<div className="statBox__row statBox__row--quad">
								<div className="statBox__box">
									<h3 className="statBox__title">Realtor Sales - Week {this.state.selectedWeek}</h3>
									{this.realtorPercent()}
								</div>
								<div className="statBox__box">
									<h3 className="statBox__title">
										Cancellation Rate - Week {this.state.selectedWeek}
									</h3>
									{this.bustRate()}
								</div>
								<div className="statBox__box">
									<h3 className="statBox__title">Realtor Sales - YTD</h3>
									{this.ytdRealtorPercent()}
								</div>
								<div className="statBox__box">
									<h3 className="statBox__title">Cancellation Rate - YTD</h3>
									{this.ytdBustRate()}
								</div>
							</div>
							<div className="statBox__row statBox__row--double">
								<div className="statBox__box">
									<h3 className="statBox__title">Net Sales To Date</h3>
									{this.salesTD()}
								</div>
							</div>
						</div>
					</div>
					<div className="statBox">
						<div className="imageGroup hideMobile">
							<div className="statBox__row">
								<div className="statBox__box">
									<h3 className="statBox__title">Sales Variance</h3>
									{this.salesVariance()}
								</div>
							</div>
						</div>
						{this.outputCommunityPerformance("bottom")}
						<div className="imageGroup hideMobile">
							{this.outputSalesAnalysis("bottom")}
							<div className="statBox__row">
								<div className="statBox__box">
									<h3 className="statBox__title">Cumulative Sales Analysis</h3>
									{this.cumulativeSales()}
								</div>
							</div>
							<div className="statBox__row statBox__row--double">
								{/* <div className="statBox__box">{this.inventoryStatus()}</div> */}
								<div className="statBox__box">{this.salesOpportunities()}</div>
								<div className="statBox__box">
									<h3 className="statBox__title">Vacant Lot Inventory</h3>
									{this.builderVacantLots()}
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		loadingStatus: state.loadingStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getExecWeeklyPayloadInternal,
		},
		dispatch
	)
}

export default compose(connect(mapStateToProps, matchDispatchToProps))(Executive)
